import React from 'react';
import classNames from 'classnames';

import { WindowTypeName, windowTypeToClassName } from 'app/utils/useWindowType';
import { RepeatComponent } from 'app/component/repeat-component/RepeatComponent';
import { RowSkeleton } from 'app/component/skeleton/row/RowSkeleton';
import 'app/component/skeleton/row/RowListSkeleton.less';

export interface RowListSkeletonProps {
    /**
     * Тип окна.
     */
    windowType: WindowTypeName;
    /**
     * Количество строк.
     */
    rowCount: number;
    /**
     * CSS класс.
     */
    className?: string;
}

/**
 * Скелетон компонента списка строк.
 */
export const RowListSkeleton = (props: RowListSkeletonProps) => {
    const className = classNames(
        'rowListSkeleton',
        props.className,
        windowTypeToClassName(props.windowType),
    );

    return (
        <RepeatComponent
            numberRepetitions={props.rowCount}
            className={className}
        >
            <RowSkeleton windowType={props.windowType} />
        </RepeatComponent>
    );
};
